import i18next from "i18next";
import React from "react";
import { Info, Mail, Phone } from "react-feather";
import Notification from "../Notification";
import PropTypes from "prop-types";
import { fetchStoreData } from "~/assets/js/Api/storeApi";

export const ContactNotification = ({ storeId }) => {
    const { store, isLoading } = fetchStoreData(storeId);

    return (
        <Notification
            customClass="contact-notification"
            icon={<Info />}
            title={i18next.t("orderConfirmation.contactInfo.heading")}
        >
            {!isLoading && (
                <ul className="contact-notification__list">
                    <li className="contact-notification__list-item">
                        <Mail size={18} />
                        <span>
                            {store.email
                                ? store.email
                                : i18next.t(
                                      "orderConfirmation.contactInfo.email"
                                  )}
                        </span>
                    </li>
                    <li className="contact-notification__list-item">
                        <Phone size={18} fill="currentColor" />
                        <span>{store.phone}</span>
                    </li>
                </ul>
            )}
        </Notification>
    );
};

ContactNotification.propTypes = {
    storeId: PropTypes.number,
};
